import {
  Component,
  Input,
  OnChanges
} from '@angular/core';
import { ModelModel } from '../models/model.model';
import { TableRowModel } from '../models/tablerow.model';
import {ProductCategoryService} from '../services/product-category.service';

@Component({
  selector: 'app-model-details-resources',
  template: `
  <div>
      <h2 class="resourcesTitle">Resources </h2>
      <div style="height: 28px"></div>
      <div>
        <table class="table table-striped">
          <thead>
            <tr>
              <th class="tableHeader">Downloads</th>
              <th class="tableHeader">Title</th>
              <th class="tableHeader">Category</th>
              <th class="tableHeader">Document Type</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let data of rowsToShow">
              <td style="text-align: center;"><a target="_blank" href="{{data?.cells[0]}}"><img style="height:30px;width:30px" src="/angular/dist/assets/download-icon.svg" alt="Download" /></a></td>
              <td style="text-align: center;">{{data?.cells[1]}}</td>
              <td style="text-align: center;">{{data?.cells[2]}}</td>
              <td style="text-align: center;">{{data?.cells[4]}}</td>
            </tr>
          </tbody>
        </table>
      </div>
  </div>
  `,
  styles: [
    `
      .resourcesTitle {
        color: #a50034;
        font-family: 'LGEIBold';
        font-size: 28px;
        text-align: left;
      }

      .tableHeader {
        background-color: #a50034;
        color: #ffffff;
        font-family: 'LGEIBold';
        font-size: 18px;
        text-align: center;
        line-height: 1.8;
      }

      .activeSelection {
        font-size: 20.1px;
        text-align: left;
        color: #4a4a4a;
        font-family: 'LGEIBold';
        border-radius: 0px;
        border-bottom-width: 4px;
        border-bottom-style: solid;
        border-bottom-color: #a50034;
        background-color: transparent !important;
        margin-right: 50px;
        cursor: pointer;
      }

      .inactiveSelection {
        font-size: 20.1px;
        text-align: left;
        color: #4a4a4a;
        font-family: 'LGEIRegular';
        border-radius: 0px;
        border-bottom-width: 0px;
        background-color: transparent !important;
        margin-right: 50px;
        cursor: pointer;
      }

      @media only screen and (max-width: 480px) {
        .nav {
          flex-wrap: nowrap !important;
        }

        .inactiveSelection {
          margin-right: 20px;
          font-size: 15px;
        }

        .activeSelection {
          margin-right: 20px;
          font-size: 15px;
        }

        .tableHeader {
          font-size: 15px;
        }
      }
    `
  ]
})
export class ModelDetailsResourcesComponent implements OnChanges {
  @Input() model: ModelModel;
  rowsToShow: TableRowModel[] = [];
  categories: string[] = [];
  selectedcategory = '';

  submittalsTableRows: TableRowModel[] = [];
  manualsTableRows: TableRowModel[] = [];
  prodWarTableRows: TableRowModel[] = [];
  marketingTableRows: TableRowModel[] = [];
  showSubmittals: Boolean = true;
  showManuals: Boolean = false;
  showProdWar: Boolean = false;
  showMarketing: Boolean = false;
  submittalClassName = 'activeSelection';
  manualsClassName = 'inactiveSelection';
  prodWarClassName = 'inactiveSelection';
  marketingClassName = 'inactiveSelection';
  archiveUrl: string;
  archiveFound = false;

  constructor(private service: ProductCategoryService) {

  }

  ngOnChanges() {
    const filteredresources = this.model.resources;
    filteredresources.forEach(r => {

      let shouldShow = r.notOnWeb == null || r.notOnWeb === false;
      const todaysdate = new Date(Date.now());
      if (r.publishon && r.unpublishon) {
        const publishdate = new Date(r.publishon);
        const unpublishdate = new Date(r.unpublishon);

        if ( todaysdate < publishdate || todaysdate > unpublishdate)  {
          shouldShow = false;
        }
      }

      if (shouldShow) {
        const tblRow: TableRowModel = new TableRowModel();
        tblRow.cells = [];
        tblRow.cells.push(r.documenturi);
        tblRow.cells.push(r.name);
        tblRow.cells.push(r.documentcategory);
        if (r.filetype === 'pdf' || r.filetype === 'PDF') {
          tblRow.cells.push('/angular/dist/assets/pdf-icon.svg');
        }else {
          tblRow.cells.push('#');
        }
        tblRow.cells.push(r.documenttype.join(";"));

        this.rowsToShow.push(tblRow);
      }

    });

  }

  getClass(name: string) {
    this.selectedcategory = name;

    if (this.selectedcategory) {
      this.rowsToShow = [];
      const filteredresources = this.model.resources.filter(x => x.documentcategory === this.selectedcategory);
      filteredresources.forEach(r => {

        let shouldShow = true;
        const todaysdate = new Date(Date.now());
        if (r.publishon && r.unpublishon) {
          const publishdate = new Date(r.publishon);
          const unpublishdate = new Date(r.unpublishon);

          if ( (todaysdate < publishdate || todaysdate > unpublishdate ) || (r.notOnWeb && r.notOnWeb === true)) {
            shouldShow = false;
          }
        }

        if (shouldShow) {
          const tblRow: TableRowModel = new TableRowModel();
          tblRow.cells = [];
          tblRow.cells.push(r.documenturi);
          tblRow.cells.push(r.name);
          if (r.filetype === 'pdf' || r.filetype === 'PDF') {
            tblRow.cells.push('/angular/dist/assets/pdf-icon.svg');
          } else {
            tblRow.cells.push('#');
          }
          tblRow.cells.push(r.documenttype.join(";"));

          this.rowsToShow.push(tblRow);
        }

      });

    }
  }

  async doesArchiveExist() {
    return await this.service.doesFileExist(this.archiveUrl);
  }

}



// WEBPACK FOOTER //
// ./src/app/product-category/components/model-details-resources.component.ts